export default __webpack_public_path__ + "assets/images/8517d512998d6921f0c099aa6e609c0a.jpg";